import 'bootstrap';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'slick-carousel';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Validation {
    constructor() {
        
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		$('.form-container').on('click.validate focusin.validate focusout.validate keyup.validate', e => this.onFormChanged(e));
        $('.form-container').on('focusout.validate', e => this.onFormBlurred(e));
    }

    onFormBlurred(e) {
        $(e.target).valid();
        this.onFormChanged(e);
    }

    onFormChanged(e) {
        let target = $(e.currentTarget);
        let children = $(target).find('.form-control');

        $(children).each((i, el) => {
            let field = $(el);
            let group = field.closest('.form-group');

            group.removeClass('form-error').removeClass('form-success');

            if (field.hasClass('input-validation-error') && !field.hasClass('valid')) {
                group.addClass('form-error');
            }
            else if ($(field).val() !== '' && !field.hasClass('input-validation-error') && field.hasClass('valid')) {
                group.addClass('form-success');
            }

            group.find('.form-error-desc').removeAttr('style');
        });
    }
}

export default Validation;